import queryString from "query-string";
import { useNavigate } from "./Components/Link";
import { useGlobalStatusContext } from "./GlobalStore";

export default function StateFromURL() {
  const {
    chain,
    setChain,
    setPeriod,
    setHotLpSortBy,
    setHotTokenSortBy,
    setRankDir,
    setShowNetAssetFlow,
    setHideInter,
    setAllowDifferent,
    setDisableReverseDebt,
    setIncludeGasFee,
  } = useGlobalStatusContext();

  const navigate = useNavigate();

  const qs: any = queryString.parse(window.location.search);
  if (["bsc", "ethereum"].includes(qs["chain"])) {
    setChain(qs["chain"]);
    delete qs["chain"];
  }

  const pathChain = window.location.pathname.match(/bsc|ethereum/)?.[0];
  if (
    pathChain &&
    ["bsc", "ethereum"].includes(pathChain) &&
    pathChain !== chain
  ) {
    setChain(pathChain);
    console.log("setChain", pathChain);
  }
  if (["1", "7", "30", "latest30"].includes(qs["period"])) {
    setPeriod(qs["period"]);
    delete qs["period"];
  }

  if (["volume", "vroc"].includes(qs["hot-token-sort-by"])) {
    setHotTokenSortBy(qs["hot-token-sort-by"]);
    delete qs["hot-token-sort-by"];
  }

  if (["volume", "vroc"].includes(qs["hot-lp-sort-by"])) {
    setHotLpSortBy(qs["hot-lp-sort-by"]);
    delete qs["hot-lp-sort-by"];
  }
  if (["tb", "lr", "bt", "rl"].includes(qs["rankdir"]?.toLowerCase())) {
    setRankDir(qs["rankdir"]?.toUpperCase());
  }

  if (["1", "0"].includes(qs["show-net-asset-flow"]?.toLowerCase())) {
    setShowNetAssetFlow(qs["show-net-asset-flow"] === "1");
  }
  if (["1", "0"].includes(qs["hide-inter"]?.toLowerCase())) {
    setHideInter(qs["hide-inter"] === "1");
  }
  if (["1", "0"].includes(qs["allow-different"]?.toLowerCase())) {
    setAllowDifferent(qs["allow-different"] === "1");
  }
  if (["1", "0"].includes(qs["disable-reverse-debt"]?.toLowerCase())) {
    setDisableReverseDebt(qs["disable-reverse-debt"] === "1");
  }
  if (["1", "0"].includes(qs["include-gas-fee"]?.toLowerCase())) {
    setIncludeGasFee(qs["include-gas-fee"] === "1");
  }

  let newQsStr = queryString.stringify(qs);
  newQsStr = newQsStr ? `?${newQsStr}` : newQsStr;

  if (newQsStr !== window.location.search) {
    navigate(window.location.pathname + newQsStr + window.location.hash, {
      replace: true,
    });
  }

  return null;
}
